import { ImportRoomUsersJobEntity, ImportRoomUsersJobResponse } from 'src/types'

export const ImportRoomUsersJobTranslator = {
  toEntity: (response: ImportRoomUsersJobResponse): ImportRoomUsersJobEntity => {
    const { jobId, status, errorDetails, errorMessage, lineCount, errorReportS3Url, updatedAt } =
      response

    return {
      jobId,
      status:
        status === 'processing'
          ? 'processing'
          : status === 'successful'
          ? 'successful'
          : status === 'failed'
          ? 'failed'
          : 'partFailed',
      totalCount: lineCount,
      errorDetails: errorDetails ?? [],
      errorMessage: errorMessage ?? undefined,
      errorReportS3Url: errorReportS3Url ?? undefined,
      updatedAt: new Date(updatedAt),
    }
  },
} as const
